import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
    Spinner,
    Modal,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup
} from "reactstrap";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "@testing-library/react";
import { Formik } from 'formik';
import * as yup from 'yup';


const Auditlog = ({
    isVisible = false,
    userDetails,
    adDetails,
    areaDropdown,
    setShowSpinner,
    setLogView,
    showModal,
    authAxios,
    fromScreen,
    ...props
}) => {
    const signUpValidationSchema = yup.object().shape({
        email: yup
            .string()
            .email("Please enter valid email")
            .required('email is required')
    });
    const formRef = React.createRef();
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [valueAreaDropdown, setValueAreaDropdown] = useState(
        fromScreen === 'locownerad' && areaDropdown?.length > 0 ? areaDropdown[0] : null
    );


    const setvalueAreaDropdownFunc = (value) => {
        setValueAreaDropdown(value);
    }

    const renderDatePicker = () => {
        if (fromScreen == 'user' || fromScreen == 'locownerad') {
            return (
                <DatePicker
                    selectsRange={true}
                    filterDate={(date) => {
                        const toIndiaTime = (utcDate) => {
                            if (!utcDate) return null;
                            const dateObj = new Date(utcDate);
                            if (isNaN(dateObj)) return null; // Ensure the date is valid
                            const formatter = new Intl.DateTimeFormat('en-IN', {
                                timeZone: 'Asia/Kolkata',
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit'
                            });
                            const parts = formatter.formatToParts(dateObj);
                            const formattedDate = new Date(`${parts[4].value}-${parts[2].value}-${parts[0].value}T${parts[6].value}:${parts[8].value}:${parts[10].value}`);
                            return formattedDate;
                        };
                        const expiryDate = toIndiaTime(adDetails?.expirydate?.replace(' ', 'T') + 'Z');
                        const minDate = toIndiaTime(adDetails?.adcreated?.replace(' ', 'T') + 'Z');

                        if (!expiryDate || !minDate) return false;
                        
                        const dateWithoutTime = new Date(date.toDateString());
                        const expiryDateWithoutTime = new Date(expiryDate.toDateString());
                        const minDateWithoutTime = new Date(minDate.toDateString());
                        return dateWithoutTime <= expiryDateWithoutTime && dateWithoutTime >= minDateWithoutTime;
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        setDateRange(update);
                    }}
                    dateFormat="MMM d, yyyy"
                    showYearDropdown
                    dropdownMode="select"
                    isClearable={true}
                    className="datePickerBox"
                />
            );
        } else if (fromScreen == 'locowner') {
            return (
                <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        setDateRange(update);
                    }}
                    dateFormat="MMM d, yyyy"
                    showYearDropdown
                    dropdownMode="select"
                    isClearable={true}
                    className="datePickerBox"
                    maxDate={new Date()}
                    minDate={new Date(new Date().setMonth(new Date().getMonth() - 6))}
                />
            );

        } else {
            return (<></>);

        }

    }

    const renderLocSelect = () => {
        return (
                <Select
                    classNamePrefix="reactSelectDropdownData"
                    value={valueAreaDropdown}
                    onChange={setvalueAreaDropdownFunc}
                    options={areaDropdown}
                    isSearchable={true}
                    placeholder="Location"
                    className="reactSelectDropdownLogView"
                />
        );

    }

    const fetchLog = async (type) => {
        try {
            formRef.current.setTouched({ email: true });
            let res = await formRef.current.validateForm();
            let fromWhichScreen = fromScreen;
            if (fromScreen == 'locownerad') {
                fromWhichScreen = 'user';
            }  
            if (res.email === undefined) {
                setShowSpinner(true);
                let url = '/getlog';
                let data;
                let location = 0;

                if (type == 'all') {
                    if (fromScreen == 'locownerad') {
                        data = {
                            data: {
                                adid: adDetails?.adid || null,
                                startdate: null,
                                enddate: null,
                                location: valueAreaDropdown,
                                type: 'all',
                                email: formRef.current?.values?.email || null,
                                from: fromWhichScreen
                            }
                        };
                    } else {
                        data = {
                            data: {
                                adid: adDetails?.adid || null,
                                startdate: null,
                                enddate: null,
                                location: null,
                                type: 'all',
                                email: formRef.current?.values?.email || null,
                                from: fromWhichScreen
                            }
                        };
                    }
                    
                } else {
                    if (startDate == null || endDate == null) {
                        setShowSpinner(false);
                        showModal('Please select date range');
                        return;
                    }
                    if (!valueAreaDropdown || valueAreaDropdown.value == null) {
                        location = { label: "All", value: 0 };
                    } else {
                        location = valueAreaDropdown;
                    }
                    const formatDate = (date) => {
                        if (!date) return null;
                        const d = new Date(date);
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                    };

                    const formatDateWithTime = (date, type) => {
                        const formattedDate = formatDate(date);
                        if (type === 'start') {
                            return formattedDate ? `${formattedDate} 00:00:00.000` : null;
                        } else {
                            return formattedDate ? `${formattedDate} 23:59:59.000` : null;
                        }                        
                    };

                    data = {
                        data: {
                            adid: adDetails?.adid || null,
                            startdate: formatDateWithTime(startDate, 'start'),
                            enddate: formatDateWithTime(endDate, 'end'),
                            location: location,
                            email: formRef.current?.values?.email || null,
                            type: 'range',
                            from: fromWhichScreen
                        }
                    };
                }

                const response = await authAxios.post(url, data);

                let result = response.data;
                if (result.data.msg == 'success') {
                    showModal("Your logs are sent to your email. Please check your inbox and spam folder as well.");
                    setLogView(false);
                    setShowSpinner(false);
                } else {
                    throw (result.data.error === undefined) ? 'Server error. Please re-submit or re-login' : result.data.error;
                }
            } else {
                setShowSpinner(false);
                showModal('Please enter valid email');
                return;
            }

        } catch (error) {
            if (typeof error === 'undefined') {
                showModal(error);
            } else {
                showModal("Server Error. Please refresh or relogin");
            }
            setShowSpinner(false);
        }

    }

    const renderLogView = () => {
        if (isVisible) {
            return (
                <Row>
                    <Col className="ml-auto mr-auto">
                        <div className="logViewContainer">
                            <div className="logViewContainerSubmit">
                                <span style={{ paddingTop: "12px" }}>Email:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <Formik
                                    validationSchema={signUpValidationSchema}
                                    enableReinitialize={true}
                                    initialValues={{
                                        email: (userDetails.email) ? userDetails.email : ''
                                    }}
                                    innerRef={formRef}
                                    validateOnChange={true}
                                >
                                    {({
                                        handleChange,
                                        handleSubmit,
                                        handleBlur,
                                        isValid,
                                        setFieldValue,
                                        setFieldTouched,
                                        values,
                                        touched,
                                        errors
                                    }) => (
                                        <>
                                            <Form className="register-form">
                                                <InputGroup className="form-group-with-border">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="nc-icon nc-email-85" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input
                                                        id="email"
                                                        placeholder="Email Address"
                                                        type="email"
                                                        value={values.email}
                                                        onChange={handleChange('email')}
                                                        onBlur={handleBlur('email')}
                                                    />
                                                </InputGroup>
                                                {errors.email && touched.email && (
                                                    <div className="input-feedback">{errors.email}</div>
                                                )}
                                            </Form>
                                        </>
                                    )}
                                </Formik>
                            </div>
                            <div className="logViewContainerDates">

                                <div className="logViewFeilds">
                                    <span>Date Range:&nbsp;&nbsp;</span>
                                    {renderDatePicker()}
                                </div>
                                <div className="logViewFeilds">
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;Location:&nbsp;&nbsp;</span>
                                    {renderLocSelect()}
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                </div>
                                <div className="logViewFeilds">
                                    <Button
                                        className="btn-round"
                                        color="primary"
                                        type="button"
                                        onClick={() => fetchLog('range')}
                                    >
                                        <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Get Logs&nbsp;</span>
                                    </Button>
                                </div>


                            </div>
                            <div className="logViewContainerSubmit">
                                <span>(Or)&nbsp;&nbsp;&nbsp;</span>
                                <Button
                                    className="btn-round"
                                    color="primary"
                                    type="button"
                                    onClick={() => fetchLog('all')}
                                >
                                    <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Get all logs&nbsp;</span>
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        } else {
            return (
                <></>
            );
        }
    }

    return (
        <>
            {renderLogView()}
        </>
    );
};

export default Auditlog;